<template>
    <img v-if="show_button" class="question-btn" @click="showModal()" :src="env.public_base + '/assets/images/question.gif'">
</template>

<script>
    import env from '../env';
    import { mapGetters } from 'vuex';

    export default {
        name: "QuestionButton",
        props: ['content_slug'],
        data: () => ({
                env,
            }),
        computed: {
            ...mapGetters([
                'userData',
            ]),
            show_button() {
                return this.userData && typeof env.params[this.userData.school_id].show_question_button !== "undefined" &&
                        env.params[this.userData.school_id].show_question_button
            },
        },
        methods: {
            showModal() {
                this.$store.dispatch('getModalContent', this.content_slug)
                    .then(() => {
                        this.$modal.show('questionModal')
                     });
            }
        }
    }
</script>

<style scoped>
    .question-btn{
        width: 30px;
        height: 30px;
        border-radius: 30px;
        background-color: #eef8fc;
        border: 1px solid #dbdbdb;
        cursor: pointer;
    }
</style>